import {
    FETCH_SUBCATEGORIES,
    FETCH_SUBCATEGORIES_FAILURE,
    FETCH_SUBCATEGORIES_SUCCESS,

    FETCH_SUBCATEGORY,
    FETCH_SUBCATEGORY_FAILURE,
    FETCH_SUBCATEGORY_SUCCESS,

    FETCH_SUBCATEGORY_LOCALISATION,
    FETCH_SUBCATEGORY_LOCALISATION_FAILURE,
    FETCH_SUBCATEGORY_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const fetchSubcategories = (payload) => {
    const params = {
        size: payload.size || 24,
        sort_by: payload.field || 'name',
        sort_direction: 'desc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    return {
        type: FETCH_SUBCATEGORIES,
        payload: params,
    };
};

export const fetchSubcategoriesFailure = (error) => {
    return {
        type: FETCH_SUBCATEGORIES_FAILURE,
        error: error,
    };
};

export const fetchSubcategoriesSuccess = (payload) => {
    return {
        type: FETCH_SUBCATEGORIES_SUCCESS,
        payload: payload,
    };
};

export const fetchSubcategory = (payload) => {
    return {
        type: FETCH_SUBCATEGORY,
        payload: payload,
    };
};

export const fetchSubcategoryFailure = (error) => {
    return {
        type: FETCH_SUBCATEGORY_FAILURE,
        error: error,
    };
};

export const fetchSubcategorySuccess = (response) => {
    return {
        type: FETCH_SUBCATEGORY_SUCCESS,
        response: response,
    };
};

export const fetchSubcategoryLocalisation = (payload) => {
    return {
        type: FETCH_SUBCATEGORY_LOCALISATION,
        payload: payload,
    };
};

export const fetchSubcategoryLocalisationFailure = (error) => {
    return {
        type: FETCH_SUBCATEGORY_LOCALISATION_FAILURE,
        error: error,
    };
};

export const fetchSubcategoryLocalisationSuccess = (payload, response) => {
    return {
        type: FETCH_SUBCATEGORY_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/subcategories/fetchSubcategories.js